import { useEffect, useRef, useState } from "react";
import { TabView, TabPanel } from 'primereact/tabview';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { Dropdown } from 'primereact/dropdown';
import { Dialog } from 'primereact/dialog';
import { InputTextarea } from 'primereact/inputtextarea';
import { Toast } from 'primereact/toast';
import { Tag } from 'primereact/tag';
import { InputSwitch } from 'primereact/inputswitch';
import leadService from '../../services/LeadService';
import adminService from '../../services/AdminService';

export default function SystemAdminPage() {
    const [mounted, setMounted] = useState(false);
    useEffect(() => { setMounted(true); }, []);
    const [leads, setLeads] = useState([]);
    const [users, setUsers] = useState([]);
    const [loading, setLoading] = useState(true);
    const [searchTerm, setSearchTerm] = useState('');
    const [selectedStatus, setSelectedStatus] = useState(null);
    const [leadDialog, setLeadDialog] = useState(false);
    const [editMode, setEditMode] = useState(false);
    const [lead, setLead] = useState({ fullName: '', companyName: '', phone: '', email: '', status: 1, note: '' });

    const [passwordDialog, setPasswordDialog] = useState(false);
    const [selectedUser, setSelectedUser] = useState(null);
    const [newPassword, setNewPassword] = useState('');

    const toast = useRef(null);

    const statuses = [
        { label: 'Yeni Kayıt', value: 1 },
        { label: 'Arandı', value: 2 },
        { label: 'Demo Yapıldı', value: 3 },
        { label: 'Aktif Kullanıyor', value: 4 },
        { label: 'Vazgeçti', value: 5 }
    ];

    useEffect(() => {
        loadLeads();
        loadUsers();
    }, []);

    useEffect(() => {
        loadLeads();
    }, [searchTerm, selectedStatus]);

    const loadLeads = async () => {
        setLoading(true);
        try {
            const res = await leadService.getAll(searchTerm, selectedStatus);
            if (res.data.success) setLeads(res.data.data);
        } catch (error) {
            toast.current.show({ severity: 'error', summary: 'Hata', detail: 'Leads yüklenemedi' });
        } finally {
            setLoading(false);
        }
    };

    const loadUsers = async (search = '') => {
        setLoading(true);
        try {
            const res = await adminService.getAllUsers(search);
            if (res.data.success) setUsers(res.data.data);
        } catch (error) {
            toast.current.show({ severity: 'error', summary: 'Hata', detail: 'Kullanıcılar yüklenemedi' });
        } finally {
            setLoading(false);
        }
    };

    const toggleUserStatus = async (user) => {
        try {
            const res = await adminService.toggleUserActive(user.id);
            if (res.data.success) {
                toast.current.show({ severity: 'success', summary: 'Başarılı', detail: res.data.message });
                loadUsers();
            }
        } catch (error) {
            toast.current.show({ severity: 'error', summary: 'Hata', detail: 'Kullanıcı durumu güncellenemedi' });
        }
    };

    const openPasswordDialog = (user) => {
        setSelectedUser(user);
        setNewPassword('');
        setPasswordDialog(true);
    };

    const savePassword = async () => {
        if (!newPassword || newPassword.length < 6) {
            toast.current.show({ severity: 'warn', summary: 'Uyarı', detail: 'Şifre en az 6 karakter olmalıdır' });
            return;
        }
        try {
            const res = await adminService.changeUserPassword(selectedUser.id, newPassword);
            if (res.data.success) {
                toast.current.show({ severity: 'success', summary: 'Başarılı', detail: 'Şifre değiştirildi' });
                setPasswordDialog(false);
            }
        } catch (error) {
            toast.current.show({ severity: 'error', summary: 'Hata', detail: 'Şifre değiştirilemedi' });
        }
    };

    const saveLead = async () => {
        try {
            const res = editMode ? await leadService.update(lead) : await leadService.create(lead);
            if (res.data.success) {
                toast.current.show({ severity: 'success', summary: 'Başarılı', detail: 'Kayıt başarılı' });
                loadLeads();
                setLeadDialog(false);
            }
        } catch (error) {
            toast.current.show({ severity: 'error', summary: 'Hata', detail: 'Hata oluştu' });
        }
    };

    const getStatusSeverity = (s) => {
        const map = { 1: 'info', 2: 'warning', 3: 'help', 4: 'success', 5: 'danger' };
        return map[s] || null;
    };

    return (
        <div className="card border-none shadow-sm rounded-2xl p-4 bg-white">
            <Toast ref={toast}  appendTo={mounted ? document.body : "self"} />
            <h2 className="mb-4 text-slate-800 font-bold flex items-center gap-2">
                <i className="pi pi-shield text-blue-600"></i> Sistem Yönetimi
            </h2>

            <TabView>
                <TabPanel header="Lead / Başvurular" leftIcon="pi pi-users mr-2">
                    <div className="flex flex-wrap gap-2 align-items-center justify-content-between mb-4">
                        <div className="flex flex-wrap gap-2">
                            <span className="p-input-icon-left">
                                <i className="pi pi-search" />
                                <InputText type="search" onInput={(e) => setSearchTerm(e.target.value)} placeholder="Ara..." className="p-inputtext-sm" />
                            </span>
                            <Dropdown value={selectedStatus} options={statuses} onChange={(e) => setSelectedStatus(e.value)}  placeholder="Durum Seç" showClear className="p-inputtext-sm" />
                            <Button label="Yeni Ekle" icon="pi pi-plus" severity="success" onClick={() => { setLead({ fullName: '', companyName: '', phone: '', email: '', status: 1, note: '' }); setEditMode(false); setLeadDialog(true); }} className="p-button-sm" />
                        </div>
                    </div>
                    <DataTable value={leads} loading={loading} rows={10} paginator responsiveLayout="stack" breakpoint="960px" className="p-datatable-sm" sortField="createdDate" sortOrder={-1}>
                        <Column field="fullName" header="Ad Soyad" sortable />
                        <Column field="companyName" header="Firma" sortable />
                        <Column field="phone" header="Telefon" sortable />
                        <Column field="email" header="E-posta" sortable />
                        <Column field="createdDate" header="Kayıt Tarihi" sortable body={(r) => new Date(r.createdDate).toLocaleDateString('tr-TR')} />
                        <Column field="status" header="Durum" body={(r) => <Tag value={r.statusText} severity={getStatusSeverity(r.status)} />} sortable />
                        <Column body={(r) => <Button icon="pi pi-pencil" rounded text severity="info" onClick={() => { setLead({ ...r }); setEditMode(true); setLeadDialog(true); }} />} />
                    </DataTable>
                </TabPanel>

                <TabPanel header="Sistem Kullanıcıları" leftIcon="pi pi-user mr-2">
                    <div className="flex flex-wrap gap-2 align-items-center justify-content-between mb-4">
                        <span className="p-input-icon-left">
                            <i className="pi pi-search" />
                            <InputText type="search" onInput={(e) => loadUsers(e.target.value)} placeholder="Kullanıcı Ara..." className="p-inputtext-sm" />
                        </span>
                    </div>
                    <DataTable value={users} loading={loading} rows={10} paginator responsiveLayout="stack" breakpoint="960px" className="p-datatable-sm">
                        <Column field="fullName" header="Ad Soyad" sortable />
                        <Column field="email" header="E-posta" sortable />
                        <Column field="tenantName" header="Şirket" sortable />
                        <Column field="role" header="Rol" sortable />
                        <Column field="lastLoginDate" header="Son Giriş" body={(r) => r.lastLoginDate ? new Date(r.lastLoginDate).toLocaleString('tr-TR') : '-'} sortable />
                        <Column field="isActive" header="Aktif/Pasif" body={(r) => (
                            <div className="flex items-center gap-2">
                                <InputSwitch checked={r.isActive} onChange={() => toggleUserStatus(r)} />
                                <Tag severity={r.isActive ? 'success' : 'danger'} value={r.isActive ? 'Aktif' : 'Pasif'} />
                            </div>
                        )} />
                        <Column body={(r) => (
                            <Button icon="pi pi-key" label="Şifre Değiştir" rounded text severity="warning" onClick={() => openPasswordDialog(r)} className="p-button-sm" />
                        )} />
                    </DataTable>
                </TabPanel>
            </TabView>

            {/* Lead Dialog */}
            <Dialog visible={leadDialog} style={{ width: '450px', height: '90vh' }} header={editMode ? "Kayıt Düzenle" : "Yeni Kayıt"} modal className="p-fluid" footer={
                <div className="flex justify-end gap-2"><Button label="İptal" icon="pi pi-times" text onClick={() => setLeadDialog(false)} /><Button label="Kaydet" icon="pi pi-check" onClick={saveLead} /></div>
            } onHide={() => setLeadDialog(false)}>
                {!editMode && (
                    <>
                        <div className="field mb-3"><label className="font-bold block mb-2 text-sm">Ad Soyad</label><InputText value={lead.fullName} onChange={(e) => setLead({ ...lead, fullName: e.target.value })} required autoFocus className="!py-2.5 !rounded-xl" /></div>
                        <div className="field mb-3"><label className="font-bold block mb-2 text-sm">Firma Adı</label><InputText value={lead.companyName} onChange={(e) => setLead({ ...lead, companyName: e.target.value })} required className="!py-2.5 !rounded-xl" /></div>
                        <div className="field mb-3"><label className="font-bold block mb-2 text-sm">Telefon</label><InputText value={lead.phone} onChange={(e) => setLead({ ...lead, phone: e.target.value })} required className="!py-2.5 !rounded-xl" /></div>
                        <div className="field mb-3"><label className="font-bold block mb-2 text-sm">E-posta</label><InputText value={lead.email} onChange={(e) => setLead({ ...lead, email: e.target.value })} required className="!py-2.5 !rounded-xl" /></div>
                    </>
                )}
                <div className="field mb-3"><label className="font-bold block mb-2 text-sm">Durum</label><Dropdown value={lead.status} options={statuses} onChange={(e) => setLead({ ...lead, status: e.value })} placeholder="Durum Seç" className="!rounded-xl" appendTo="self" /></div>
                <div className="field mb-3"><label className="font-bold block mb-2 text-sm">Not</label><InputTextarea value={lead.note} onChange={(e) => setLead({ ...lead, note: e.target.value })} rows={3} className="!rounded-xl" /></div>
            </Dialog>

            {/* Password Dialog */}
            <Dialog visible={passwordDialog} style={{ width: '400px' }} header="Şifre Değiştir" modal className="p-fluid" footer={
                <div className="flex justify-end gap-2"><Button label="İptal" icon="pi pi-times" text onClick={() => setPasswordDialog(false)} /><Button label="Kaydet" icon="pi pi-check" onClick={savePassword} /></div>
            } onHide={() => setPasswordDialog(false)}>
                <div className="field">
                    <label className="font-bold block mb-2">Kullanıcı: {selectedUser?.fullName}</label>
                    <InputText value={newPassword} onChange={(e) => setNewPassword(e.target.value)} type="password" placeholder="Yeni şifre girin..." className="!py-2.5 !rounded-xl" />
                </div>
            </Dialog>
        </div>
    );
}
